import React from 'react';

const BilingualText = ({ primary, secondary, divider = '/' }) => (
  <span className='bilingual_Text'>
    <span className='bilingual_Primary'>{primary}</span>
    <span className='bilingual_Divider' aria-hidden='true'>{divider}</span>
    <span className='bilingual_Secondary'>{secondary}</span>
  </span>
);

export default BilingualText;